import {useCallback} from 'react';

import {AppsSelectionWithoutContent} from '@web-catalog/types';

import {useGetVkId} from '@web-catalog/store/auth';

import {logTmrEvent} from '../logEvent';
import {getFeaturingAnalyticsType} from '../useFeaturingAnalytics';

export const useLogCompilationCardClick = () => {
  const getVkId = useGetVkId();

  const onClick = useCallback(
    (selection: AppsSelectionWithoutContent, cardNumber: number) => {
      logTmrEvent({
        logEvent: 'compilationCard.click',
        params: {
          compilation_id: selection.id,
          compilation_name: selection.title?.value,
          compilation_num: cardNumber,
          compilation_type: getFeaturingAnalyticsType(
            selection.type,
            selection.displayType,
          ),
          vk_id: getVkId(),
        },
      });
    },
    [getVkId],
  );
  return onClick;
};
